import { useState, useEffect } from "react";
import { handleAvatar } from "../../../utils/avatar";
import { getData, getDataById } from "../../../utils/fetch";

import css from "./index.module.css";
import Header from "../../../components/Header";
import emptyImage from "../../../assets/emptyImage.png"

/**
 * Displays scoreboard page for progress with missions and challenges for students
 * @param {String} studentId 64 character uuid 
 */
const Scoreboard = ({studentId}) => {
  const [classId, setClassId] = useState(null);
  const [students, setStudents] = useState(null);
  const [challenges, setChallenges] = useState(null);
  const [challengelist, setChallengeList] = useState(null);
  const [classToMissions, setClassToMissions] = useState(null);
  const [classToChallenges, setClassToChallenges] = useState(null);
  const [selected, setSelected] = useState({type: "Mission", id: ""});

  useEffect(() => {
    getData("/api/students").then(data => {
      setStudents(data)
      setClassId(data.filter(f => f.id === studentId)[0].class_id);
      const tempClassId = data.filter(f => f.id === studentId)[0].class_id;
      getDataById("/api/classToChallenges/byId", {classId: tempClassId}).then(data => setChallengeList(data));
      getDataById("/api/join/classMissions", {classId: tempClassId}).then(data => setClassToMissions(data.filter(f => f.completed === true)));
      getDataById("/api/join/classChallenges", { classId: tempClassId }).then(data => setClassToChallenges(data.filter(f => f.completed === true)));
    });
    getData("/api/challenges").then((data) => setChallenges(data));
    
  }, [studentId]);

  /**
   * transform given time from milliseconds to hh:mm:ss:ms format
   * @param {Number} timeInMilliseconds the given timestamp in milliseconds
   * @returns hh:mm:ss:ms
   */
  const handleTime = (timeInMilliseconds) => {
    const hours = Math.floor(timeInMilliseconds/3600000);
    const minitues = Math.floor((timeInMilliseconds%3600000)/60000);
    const seconds = Math.floor((timeInMilliseconds%60000)/1000);
    const millis = timeInMilliseconds%1000;
    
    if(hours > 0 ) return hours + "h " + minitues + "m " + seconds + "s " + millis + "ms";
    if (minitues > 0) return  minitues + "m " + seconds + "s " + millis + "ms";
    if (seconds > 0 ) return  seconds + "s " + millis + "ms";
    return millis + "ms";
  };

  /**
   * determines leaderboard placement
   * @param {Number} position of arrayindex 
   * @returns css class for given position in leaderboard
   */
  const handleMedalColor = (position) => {
    switch (position) {
      case 0: return css.challengeGold;
      case 1: return css.challengeSilver;
      case 2: return css.challengeBronze;
      default: return css.challenge;
    } 
  }

  return (
    <div className={css.page}>
      <Header isTeacher={false} nav="Scoreboard"/>
      <div className={css.selectType}>
        <div className={css.header}>
          <span onClick={() => setSelected({type: "Mission", id: ""})} className={selected?.type === "Mission" ? css.selected : ""}>Missionen</span>
          <span onClick={() => setSelected({type: "Challenge", id: challenges[0]?.id })} className={selected?.type === "Challenge" ? css.selected : ""}>Challenges</span>
        </div>
        <div className={css.body}>
          {selected?.type === "Challenge" && challenges?.filter(f => challengelist?.find(ff => ff.challenge_id === f.id)).map(e => {
            return (
              <div key={e.id} onClick={() => setSelected({type: "Challenge", id: e.id})} className={selected.id === e.id ? css.selectedChallenge : ""}>
                <img src={emptyImage} alt="Challengeimage"></img>
                <span>Challenge {e.name}</span>
              </div>
            )
          })}
        </div>
      </div>
      <div className={css.challenges}>
        {selected?.type === "Challenge" && classToChallenges?.filter(f => f.challenge_id === selected.id && f.class_id === classId)?.length <= 0 && (
          <div className={css.challenge}>
            <div className={css.student}>
              <span>Bisher wurde diese Challange in deiner Klasse noch von niemandem beendet.</span>
            </div>
          </div>
        )}
        {selected?.type === "Challenge" && classToChallenges?.filter(f => f.challenge_id === selected.id).map((e,i) => {
          const result = students.find(listElement => listElement.id === e.student_id);
          const student = {name: result.use_nickname ? result.nickname : result.name};
          const result2 = students.find(listElement => listElement.id === e.student2_id);
          const student2 = {name: result2.use_nickname ? result2.nickname : result2.name};
          return (
          
              <div key={"challengeListEntry_" + e.id + "_" + i} className={handleMedalColor(i)}>
                <div className={css.student}>
                  <span>{i > 9 ? i+1 : "0" + (i+1)}.</span>
                  <div className={css.avatar}>
                    {handleAvatar(result?.use_avatar, result?.avatar, result?.name)}
                  </div>
                  <span>{student?.name ? student?.name : "kein name gefunden"}</span>
                </div>
                {student2 && <div className={css.student}>
                  <div className={css.avatar}>
                    {handleAvatar(result2?.use_avatar, result2?.avatar, result2?.name)}
                  </div>
                  <span>{student2?.name ? student2?.name : "kein name gefunden"}</span>
                </div>}
                
                <span>{handleTime(e.duration)}</span>  
              </div>

          )
        })}
      </div>
      <div className={css.missions}>
        {selected?.type === "Mission" && classToMissions?.filter(f => f.class_id === classId)?.length <= 0 && (
          <div className={css.challenge}>
            <div className={css.student}>
              <span>Bisher wurde noch keine Mission in deiner Klasse beendet.</span>
            </div>
          </div>
        )}
        {selected?.type === "Mission" && students?.filter(f => f.classid === students?.filter(e => e.id === studentId)[0].classid).map(student => {
          const result = classToMissions?.filter(f => f.student_id === student.id);
            return ( result?.length > 0 &&
              <div key={"missionListEntry_" + student.id} className={css.student}>
                <div className={css.info}>
                  <div className={css.avatar}>
                      {handleAvatar(student?.use_avatar, student?.avatar, student?.name)}
                  </div>
                  <span>{student?.name ? student?.name : "kein name gefunden"}{" " + result?.length}</span>
                </div>
                <div className={css.border}>
                  <div className={css[`length${result?.length}`]}>
                    <div></div>
                  </div>
                </div>
              </div>
            )
        })}
      </div>
    </div>
  )
};

export default Scoreboard;
